import { render, staticRenderFns } from "./messageDialog2.vue?vue&type=template&id=001976a2&scoped=true&"
import script from "./messageDialog2.vue?vue&type=script&lang=js&"
export * from "./messageDialog2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001976a2",
  null
  
)

export default component.exports